export default __webpack_public_path__ + "static/media/Member_JiaZhenLiu.77e126c0.jpg";